import { render, staticRenderFns } from "./supportBankDc.vue?vue&type=template&id=0d0acb0a&scoped=true"
import script from "./supportBankDc.vue?vue&type=script&lang=js"
export * from "./supportBankDc.vue?vue&type=script&lang=js"
import style0 from "./supportBankDc.vue?vue&type=style&index=0&id=0d0acb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0acb0a",
  null
  
)

export default component.exports